"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../../shared/components/editors/CardRowTextEditor");
var PlayerLevelLocaleEditor = /** @class */ (function (_super) {
    __extends(PlayerLevelLocaleEditor, _super);
    function PlayerLevelLocaleEditor(props) {
        return _super.call(this, props) || this;
    }
    PlayerLevelLocaleEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    title: _item.title,
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                title: ""
            });
        }
        this.doReSetRules();
    };
    PlayerLevelLocaleEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
            title_rules: { isError: false }
        });
    };
    PlayerLevelLocaleEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Название не заполнено!" } });
            return false;
        }
        return true;
    };
    PlayerLevelLocaleEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                title: this.state.title
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация уровня изменена!");
            });
        }
    };
    PlayerLevelLocaleEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                brand_bonus_level_id: this.props.rootRecord.key,
                title: this.state.title,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Локализация уровня добавлена!");
            });
        }
    };
    PlayerLevelLocaleEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    PlayerLevelLocaleEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новая локализация уровня";
        }
        else {
            return "Изменить локализацию уровня";
        }
    };
    PlayerLevelLocaleEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguages, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return PlayerLevelLocaleEditor;
}(React.Component));
exports.default = PlayerLevelLocaleEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_locales/PlayerLevelLocalesEditor.tsx
// module id = 1953
// module chunks = 0